import { put, call, takeLatest } from "redux-saga/effects";
import CONSTANTS from "./constants";
import * as SERVICES from "./services";

import Router from "@src/lib/router";
import toast from "react-hot-toast";
import { showSelectAddressBottomSheetAction } from "../../BottomSheets/store/actions";
import parseError from "@src/utils/parseError";
import {
  getAddressListAction,
  savePincodeErrorMsg,
  setActiveAddressAction,
} from "./actions";
import { store } from "@root/store";
import { getCourseCouponStudentOverview } from "@src/graphApis/index";
import { getGraphCoursePriceDetailsAction } from "../../Tabs/Overview/store/actions";
function* getAddressListSaga(data) {
  yield put({
    type: CONSTANTS.SHIPMENT_ADDRESSLIST_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.getAddressListService, data?.payload);
    const apiRes = apiCall?.data?.data?.studentAddress;

    const defaultAddress = apiCall?.data?.data?.studentAddress?.find(
      (item) => item?.isDefault
    );

    yield put({
      type: CONSTANTS.SHIPMENT_ADDRESSLIST_SUCCESS,
      payload: apiRes,
    });

    if (data?.onSuccess) {
      yield call(data?.onSuccess);
    }

    // SETTING SELECTED ADDRESS FOR THE OVERVIEW PAGE
    const activeAdressAction = yield call(
      setActiveAddressAction,
      defaultAddress
    );
    yield put({ ...activeAdressAction });
  } catch (err) {
    parseError(err);
  }
}

function* sendAddressDataSaga(data) {
  yield put({
    type: CONSTANTS.SHIPMENT_ADDRESSDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.sendAddressDataService, data?.payload);
    const apiRes = apiCall?.data?.data;

    yield put({
      type: CONSTANTS.SHIPMENT_ADDRESSDATA_SUCCESS,
      payload: apiRes,
    });

    // console.log("OFFLINEMATERIAL__ROUTER", Router, data);
    yield call(Router.push, `/${data?.payload?.courseId}/1`);

    yield put({
      type: "BOTTOMSHEET_SELECT_ADDRESS",
      payload: true,
    });
    toast.success("New Address Added Successfully!");
  } catch (err) {
    parseError(err);
  }
}

function* editAddressDataSaga(data) {
  yield put({
    type: CONSTANTS.SHIPMENT_EDITADDRESSDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(SERVICES.editAddressDataService, data?.payload);
    const apiRes = apiCall?.data?.data;

    yield put({
      type: CONSTANTS.SHIPMENT_EDITADDRESSDATA_SUCCESS,
      payload: apiRes,
    });

    if (!data?.payload?.skipUpdates) {
      yield call(Router.push, `/${data?.payload?.courseId}/1`);
      yield put({
        type: "BOTTOMSHEET_SELECT_ADDRESS",
        payload: true,
      });
      toast.success("Address Updated Successfully");
    } else {
      yield call(getAddressListSaga, { onSuccess: data.payload.onSuccess });
    }
  } catch (err) {
    parseError(err);
  }
}

function* deleteAddressDataSaga(data) {
  yield put({
    type: CONSTANTS.SHIPMENT_DELETEADDRESSDATA_LOADING,
    payload: true,
  });

  try {
    const apiCall = yield call(
      SERVICES.deleteAddressDataService,
      data?.payload
    );

    const apiRes = apiCall;
    // console.log(apiRes?.data?.message);
    toast.success(apiRes?.data?.message);

    yield put({
      type: CONSTANTS.SHIPMENT_DELETEADDRESSDATA_SUCCESS,
      payload: apiRes,
    });

    yield call(getAddressListSaga);

    yield put({
      type: "BOTTOMSHEET_DELETE_ADDRESS",
      payload: false,
    });
  } catch (err) {
    parseError(err);
  }
}

function* checkServiceableAddress(data) {
  let isDeliveryFeeHandledByTutor =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
      ?.isDeliveryFeeHandledByTutor;
  let payload = {
    pincode: data?.payload,
    isDeliveryFeeHandledByTutor,
  };
  const userToken =
    new URLSearchParams(window?.location?.search).get("token") ||
    localStorage.getItem("userToken");
  try {
    const apiCall = yield call(SERVICES.checkPincodeServiceable, payload);
    let courseId =
      store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.id;

    if (apiCall?.data?.data?.errorMessage) {
      yield put(
        savePincodeErrorMsg({
          msg: apiCall?.data?.data?.errorMessage,
          pincode: data?.payload,
          disableBuyNowBtn: true,
        })
      );
    } else {
      yield put(
        savePincodeErrorMsg({
          msg: "",
          pincode: data?.payload,
          deliveryFee: apiCall?.data?.data?.deliveryFee,
          disableBuyNowBtn: false,
        })
      );
    }

    const response = yield put(
      getGraphCoursePriceDetailsAction({
        limit: 20,
        courseIds: [courseId.toString()],
        isBundlingCourse: false,
        isPhysicalDeliveryEnabled: 2,
        token: userToken,
        avoidCouponsList: true,
      })
    );
  } catch (err) {
    console.log(err);
    parseError(err);
  }
}

export default function* physicalShipmentSaga() {
  yield takeLatest(CONSTANTS.SHIPMENT_ADDRESSLIST_GET, getAddressListSaga);
  yield takeLatest(CONSTANTS.SHIPMENT_ADDRESSDATA_POST, sendAddressDataSaga);
  yield takeLatest(CONSTANTS.SHIPMENT_EDITADDRESSDATA_PUT, editAddressDataSaga);
  yield takeLatest(CONSTANTS.SHIPMENT_SERVICEABLE, checkServiceableAddress);
  yield takeLatest(
    CONSTANTS.SHIPMENT_DELETEADDRESSDATA_DELETE,
    deleteAddressDataSaga
  );
}
